var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "content-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _vm.$slots.header
          ? _c("div", [
              _c(
                "h4",
                [
                  _vm.collapsible
                    ? _c(
                        "b-button",
                        {
                          staticClass: "section-toggle",
                          attrs: {
                            variant: "link",
                            size: "sm",
                            title: _vm.open
                              ? "Collapse Section"
                              : "Expand Section"
                          },
                          on: {
                            click: function($event) {
                              _vm.open = !_vm.open
                            }
                          }
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.open ? "chevron-down" : "chevron-right"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("header")
                ],
                2
              ),
              _vm._v(" "),
              _vm.$slots.subtitle
                ? _c("div", [_vm._t("subtitle")], 2)
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$slots.action
          ? _c("div", { staticClass: "actions" }, [_vm._t("action")], 2)
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section-inner" },
            [
              _vm.$slots.main
                ? _c("b-row", [_c("b-col", [_vm._t("main")], 2)], 1)
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }